import React from "react";
import { useNavigate } from "react-router-dom";

function BackBtn() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="am-navbar-left" role="button" onClick={handleBack}>
      <span className="am-navbar-left-content">
        <span className="return_icon">
          <svg className="am-icon am-icon-left am-icon-lg">
            <use xlinkHref="#left" />
          </svg>
        </span>
      </span>
    </div>
  );
}

export default BackBtn;
